import { render, staticRenderFns } from "./accountbalance.vue?vue&type=template&id=f6fd21ce&"
import script from "./accountbalance.vue?vue&type=script&lang=js&"
export * from "./accountbalance.vue?vue&type=script&lang=js&"
import style0 from "./accountbalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports